import CSCPTable from "../cscp-table"

export default class AbstractReport extends CSCPTable {
    constructor() {
        super();
    }

    initSettings() {
        let that = this;

        that.instance = "cscpjs.default.certifyExamReportjs";
        that.method = "/Reports/CertifyPaging";
        that.tableId = "certifyExamTable";
        that.searchBtnEleId = "certifyExamTableSearch";

        that.columns = [
            { customContent: (row) => { return row.FirstName + " " + row.LastName }, class: "column-1" },
            { data: "Email", class: "column-2" },
            { data: "SchoolName", class: "column-3" },
            {
                customContent: (row) => {
                    return `<a href="/FileDownload/DownloadFiles?id=${row.ID}&returnUrl=${that.additionalAttr.returnUrl}">
                                ${that.additionalAttr.downloadLabel}
                            </a>`}, class: "column-4"
            }
        ]
        that.filterContainerEleId = "reportFilterForm";
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/certifyExamReport.js